<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn @click="addClick" class="ml-0" color="success">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{$t('buttons.addServiceType')}}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="true"
						:headers="serviceTypesTable.headers"
						:items="serviceTypesTable.items"
						:total="serviceTypesTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.id, false)">{{ props.item.name }}</td>
								<td @click="editClick(props.item.id, false)">
									<v-icon small v-if="props.item.active">fa-check</v-icon>
								</td>
								<td>
									<v-tooltip bottom>
										<v-btn @click="editClick(props.item.id, true)" icon slot="activator">
											<v-icon small>fa-external-link-alt</v-icon>
										</v-btn>
										<span>{{$t('tooltips.openInNewTab')}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import DataTable from "./trinkets/DataTable";

	export default {
		name: "ServiceTypes",
		components: {DataTable},
		data: function () {
			return {
				serviceTypesTable: {
					headers: [
						{text: this.$t('fields.name'), value: 'name', type: 'string', searchable: 'hidden'},
						{text: this.$t('fields.active'), value: 'active', type: 'boolean_yes', width: "100px", searchable: 'hidden'},
						{text: '', value: 'actions', type: '', sortable: false, align: "right", width: "100px", searchable: false}
					],
					items: [],
					total: 0,
					lastRequest: null
				},

			}
		},
		methods: {
			addClick() {
				this.$router.push('/service-types/0')
			},
			editClick(id, newTab = false) {
				if (!newTab) {
					this.$router.push('/service-types/' + id)
				} else {
					let routeData = this.$router.resolve('/service-types/' + id);
					window.open(routeData.href, '_blank');
				}
			},
			reloadData(request) {
				this.lastRequest = request;
				let vm = this;
				this.$APICall('get', 'service-types', request, (data, success) => {
					if (success) {
						vm.serviceTypesTable.items = data.items;
						vm.serviceTypesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			},
			excelExport() {
				let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
				excelRequest.pagination.rowsPerPage = 999999999;
				excelRequest.pagination.page = 1;

				let vm = this;
				this.$APICall('get', 'service-types', excelRequest, (data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/service-types', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}, false);
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.supplierServiceTypes'), href: '/#/service-types', disabled: true}
			]);
		}
	}
</script>

<style scoped>

</style>
